import React from "react";
import data from "../data/data.json";
import Select from "./Select";
import { useMapContext } from "./MapContext";
import { replaceUmlauteBig } from "../util/uml.js";
import { useRef } from "react";
const filterFields = ["877", "882", "916", "883"];
const fields = data.HEADER.filter(({ FELD_ID }) =>
  filterFields.includes(FELD_ID)
);

export default function Filters() {
  const { addFilter } = useMapContext();
  const timeout = useRef();

  const handleChange = (e) => {
    clearTimeout(timeout.current);
    e.persist();
    // console.log({ e, type: "text", value: e.target.value });
    timeout.current = setTimeout(() => {
      addFilter({ type: "text", value: e.target.value });
    }, 800);
  };

  return (
    <div
      style={{
        maxHeight: "100%",
        maxWidth: "100%",
        overflowY: "auto",
        flexGrow: 1,
      }}
    >
      <div style={{ padding: "20px 10px 10px" }}>
        <strong style={{ marginBottom: 10, display: "block" }}>Filter</strong>
        <input
          type="text"
          placeholder="Filter nach Name, Firma, Adresse"
          onChange={handleChange}
          style={{
            boxSizing: `border-box`,
            width: `100%`,
            height: `40px`,
            padding: `0 12px`,
            fontSize: `14px`,
            outline: `none`,
            textOverflow: `ellipses`,
            border: "1px solid #ccc",
            borderRadius: 4,
          }}
        />
      </div>
      {fields.map(({ AUSGABE, DYN_VALUES }) => {
        const options = DYN_VALUES.split("\r\n").map((text) => {
          const option = text.split("~");
          return { value: option[0], label: option[1] };
        });
        return AUSGABE == "Berufe" ? null : (
          <div key={AUSGABE} style={{ padding: "10px 10px 10px" }}>
            <strong style={{ marginBottom: 10, display: "block" }}>
              {AUSGABE}
            </strong>

            <Select
              options={options}
              isMulti
              //   closeMenuOnSelect={false}
              name={replaceUmlauteBig(AUSGABE)}
              onChange={(value) =>
                addFilter({ type: replaceUmlauteBig(AUSGABE), value })
              }
              styles={{
                control: (styles) => ({
                  ...styles,
                  maxWidth: "100%",
                  width: "100%",
                }),
              }}
            />
          </div>
        );
      })}
    </div>
  );
}
